import { createPrintJob, type PreviewOptions } from "../../src/index";

// This example focuses on a compact custom-size page that behaves more like a
// packing card or warehouse handoff sheet than a standard A4 document.
export function createCodesSummaryExample() {
  const job = createPrintJob({
    title: "Codes and Summary",
    pageSize: {
      width: { value: 100, unit: "mm" },
      height: { value: 150, unit: "mm" },
      name: "Custom 100x150mm"
    },
    orientation: "portrait",
    margins: { top: "8mm", right: "8mm", bottom: "10mm", left: "8mm" },
    fontFamily: '"Segoe UI", "PingFang SC", sans-serif'
  });

  job
    .addText("Packing Card", {
      tagName: "h1",
      style: {
        margin: 0,
        fontSize: "22px",
        letterSpacing: "0.03em"
      }
    })
    .addHtml(
      `<p style="margin:0;color:#475569;font-size:12px;line-height:1.6;">
        This example uses a custom 100mm × 150mm page to demonstrate that the
        library is not limited to standard office paper. It behaves more like a
        shipping card, label sheet, or compact warehouse handoff document.
      </p>`
    )
    .addHtml(
      `<div style="display:grid;gap:8px;margin-top:6px;padding:12px;border:1px solid #cbd5e1;border-radius:16px;background:#f8fafc;">
        <div><strong>Order:</strong> CS-20260610-07</div>
        <div><strong>Zone:</strong> Cold Storage B2</div>
        <div><strong>Handler:</strong> Shift 03</div>
      </div>`,
      { keepTogether: true }
    )
    .addHtml(
      `<div style="display:flex;justify-content:space-between;align-items:flex-end;gap:20px;margin-top:6px;">
        <div style="flex:1;">
          <div style="font-size:11px;color:#6b7280;margin-bottom:6px;">Tracking barcode</div>
        </div>
        <div style="width:110px;text-align:right;">
          <div style="font-size:11px;color:#6b7280;margin-bottom:6px;">Warehouse QR</div>
        </div>
      </div>`,
      { keepTogether: true }
    )
    .addBarcode("PRINTER-20260610-CARD-01", {
      displayValue: true,
      height: 42,
      width: 1.3,
      margin: 0,
      keepTogether: true
    })
    .addQRCode("https://example.com/orders/PRINTER-20260610-CARD-01", {
      size: 96,
      margin: 0,
      keepTogether: true
    })
    .addHtml(
      `<div style="margin-top:10px;padding:14px;border:1px solid #cbd5e1;border-radius:18px;display:grid;gap:8px;font-size:12px;line-height:1.55;">
        <div><strong>Carrier:</strong> Example Freight</div>
        <div><strong>Pickup:</strong> 2026-06-10 09:00 - 12:00</div>
        <div><strong>Package type:</strong> Frozen accessories carton</div>
        <div><strong>Notes:</strong> Keep upright, confirm seal, and stage in rack C before departure.</div>
      </div>`,
      { keepTogether: true }
    );

  const previewOptions: Omit<PreviewOptions, "container"> = {
    mode: "document"
  };

  return {
    id: "codes-summary",
    title: "Codes and Summary",
    description: "A compact custom-size packing card that showcases non-standard paper, barcode density, QR placement, and warehouse metadata.",
    job,
    defaultPreviewOptions: previewOptions
  };
}
